import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Navbar from '../../components/Navbar/Navbar'
import Scrollbar from '../../components/scrollbar/scrollbar';
import Attorney from '.';
import Footer from '../../components/footer/Footer';

const OurTeam = () => {
    return (
        <Fragment>
            <PageTitle pageTitle={'Our Team'} pagesub={'Attorneys'} />
            <Attorney/>
            <Scrollbar />
        </Fragment>
    )
};
export default OurTeam;
